<template>
  <v-card v-if="event" class="pa-1 max-shadow">
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <avatar
            :text="event.author.name"
            :size="40"
            :src="event.author.photo"
          />
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>
            <span class="body-2">
              {{ event.author.name }} created an event in {{ eventType }}
            </span>
          </v-list-tile-title>
          <v-list-tile-sub-title>
            <span class="caption">
              {{ formatTime(event.createdAt) }}
            </span>
          </v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn
            v-if="!event.content.bookingId"
            color="primary"
            icon
            flat
            @click="$emit('delete', event)"
          >
            <v-icon>delete</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
      <v-img
        v-if="event.content.photo"
        style="border-radius: 6px"
        :aspect-ratio="1.3"
        :src="event.content.photo"
      />
      <v-card-title class="px-2 pt-2 pb-0 subheading font-weight-bold">
        {{ event.content.title }}
      </v-card-title>
      <v-card-title class="px-2 py-0 body-1">
        {{ event.content.description }}
      </v-card-title>
      <v-card-text class="px-2 pt-3 pb-0 caption">
        {{
          formatEventDuration(event.content.startDate, event.content.endDate)
        }}
      </v-card-text>
      <v-card-text class="px-2 py-3">
        {{ eventParticipants }}
      </v-card-text>
      <v-card-actions>
        <span class="body-1 pr-3">
          {{ likes }}
          <v-icon small> mdi-heart-outline </v-icon>
        </span>
        <span>
          {{ noOfComments }}
          <v-icon small @click="showEvent"> mdi-comment-outline </v-icon>
        </span>
      </v-card-actions>
    </v-list>
    <comments v-if="showComments" :feed-id="event.id" />
  </v-card>
</template>
<script>
import Avatar from '@/components/common/Avatar';
import * as moment from 'moment';
import _get from 'lodash/get';
import Comments from './Comments';

export default {
  name: 'Event',
  components: {
    avatar: Avatar,
    comments: Comments,
  },
  props: {
    event: {
      type: Object,
      required: true,
      default: () => {},
    },
    showComments: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    noOfComments() {
      return this.event.comments ? this.event.comments.length : 0;
    },
    likes() {
      return this.event.likes ? this.event.likes.length : 0;
    },
    eventParticipants() {
      const content = _get(this.event, 'content');
      if (!content) return;
      const eventType = content.eventType || 'facility';
      if (eventType !== 'facility') return;
      const going = content.going ? content.going.length : 0;
      const maybe = content.maybe ? content.maybe.length : 0;
      const notgoing = content.notgoing ? content.notgoing.length : 0;
      return `${going} Going | ${maybe} Maybe | ${notgoing} NotGoing`;
    },

    eventType() {
      const content = _get(this.event, 'content');
      if (!content) return 'facility';
      const eventType = content.eventType || 'facility';
      return `${eventType}`;
    },
  },
  methods: {
    formatTime(timestamp) {
      const date = timestamp.toDate();
      const today = moment().startOf('day');
      return moment(date).isAfter(today)
        ? moment(date).fromNow()
        : moment(date).calendar(today, {
            lastWeek: 'DD MMM [at] hh:mm A',
            sameElse: 'DD MMM [at] hh:mm A',
          });
    },
    showEvent() {
      if (this.noOfComments === 0) return;
      this.$emit('show-comments', this.event);
    },
    formatEventDuration(st, en) {
      if (st === undefined || en === undefined) return;
      const start = st.toDate();
      const end = en.toDate();
      const startDate = moment(start).format('YYYY-MM-DD');
      const endDate = moment(end).format('YYYY-MM-DD');
      const sameDay = moment(startDate).isSame(endDate);
      const startTime =
        moment(start).minutes() === 0
          ? moment(start).format('ha')
          : moment(start).format('h:ma');
      const endTime =
        moment(end).minutes() === 0
          ? moment(end).format('ha')
          : moment(end).format('h:ma');
      if (sameDay) {
        return `${moment(start).format(
          'ddd MMM DD, YYYY'
        )} ${startTime} - ${endTime}`;
      } else {
        return `${moment(start).format(
          'ddd MMM DD, YYYY'
        )} ${startTime} - ${moment(end).format('ddd MMM DD, YYYY')} ${endTime}`;
      }
    },
  },
};
</script>
